export const setSessStoreItem = function (key: string, data: any) {
  try {
    if (!data) throw new Error('setitem data argument required');
    let stringData = '';
    if (typeof data === 'object') {
      stringData = JSON.stringify(data);
    }
    sessionStorage.setItem(key, stringData);
  } catch (error) {
    console.error('sessionStorageTransfer', error);
  }
};

export const getSessStoreItem = function (key: string) {
  function isJson (data: string) {
    try {
      JSON.parse(data);
    } catch (e) {
      return false;
    }
    return true;
  }

  try {
    let stringData = sessionStorage.getItem(key);
    if (!stringData) return;

    if (isJson(stringData)) {
      return JSON.parse(stringData);
    } else {
      return stringData;
    }
  } catch (error) {
    console.error('sessionStorageTransfer', error);
  }
};